module.exports = __webpack_public_path__ + "static/media/CARÁTULA POSPAGO.948493bc.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/media/CARÁTULA POSPAGO.pdf
// module id = 312
// module chunks = 0